import { render } from "./DialogC.vue?vue&type=template&id=0954287f&scoped=true"
import script from "./DialogC.vue?vue&type=script&lang=js"
export * from "./DialogC.vue?vue&type=script&lang=js"

import "./DialogC.vue?vue&type=style&index=0&id=0954287f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0954287f"]])

export default __exports__